import { BodyText } from 'components/Custom/Typographies'
import { Box } from 'components/Material/index'
import React from 'react'
import cn from 'classnames'

interface LabelValuePairProps {
  label: string
  value: string | number
  breackLine?: boolean
  className?: string
}

export const LabelValuePair: React.FC<LabelValuePairProps> = ({
  label,
  value,
  breackLine,
  className
}) => {
  const hoverClass = 'hover:overflow-visible hover:break-words'

  return (
    <Box>
      <BodyText text={label} typeStyle="small" />
      <BodyText
        text={value}
        typeStyle="large"
        className={`${className} overflow-ellipsis overflow-hidden ${hoverClass}
    ${cn({ 'break-all': breackLine })}`}
      />
    </Box>
  )
}
